<h2 mat-dialog-title>{{ 'LABEL.ADVANCED_SEARCH' | translate }}</h2>

<div mat-dialog-content>
  <form [formGroup]="form" fxLayout="row wrap" fxLayoutGap="8px grid">

    <div fxFlex="100">
      <app-select-search formControlName="companyId" [items]="companies" viewField="name" [multiple]="true"
        [label]="'LABEL.COMPANY' | translate">
      </app-select-search>
    </div>

    <div fxFlex="100" *ngIf="form.get('companyId')?.value?.length"
      style="display:flex; flex-wrap:wrap; gap:4px; padding-top:0; padding-bottom:4px;">
      <span *ngFor="let item of form.get('companyId')?.value"
        style="display:inline-flex; align-items:center; background:#e0e0e0; border-radius:12px; padding:2px 4px 2px 10px; font-size:12px; line-height:20px; gap:2px;">
        {{ item.name }}
        <button type="button" (click)="removeSelection('companyId', item)"
          style="background:none; border:none; cursor:pointer; padding:0; display:flex; align-items:center; color:rgba(0,0,0,0.54);">
          <mat-icon style="font-size:16px; width:16px; height:16px; line-height:16px;">cancel</mat-icon>
        </button>
      </span>
    </div>

    <div fxFlex="100">
      <app-select-search formControlName="responsible" [items]="operators" viewField="email" [multiple]="true"
        [noUsers]="operators.length === 0" [label]="'LABEL.WORKER_ASS' | translate">
      </app-select-search>
    </div>

    <div fxFlex="100" *ngIf="form.get('responsible')?.value?.length"
      style="display:flex; flex-wrap:wrap; gap:4px; padding-top:0; padding-bottom:4px;">
      <span *ngFor="let item of form.get('responsible')?.value"
        style="display:inline-flex; align-items:center; background:#e0e0e0; border-radius:12px; padding:2px 4px 2px 10px; font-size:12px; line-height:20px; gap:2px;">
        {{ item.email }}
        <button type="button" (click)="removeSelection('responsible', item)"
          style="background:none; border:none; cursor:pointer; padding:0; display:flex; align-items:center; color:rgba(0,0,0,0.54);">
          <mat-icon style="font-size:16px; width:16px; height:16px; line-height:16px;">cancel</mat-icon>
        </button>
      </span>
    </div>

    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>{{ 'LABEL.streetName' | translate }}</mat-label>
      <input matInput formControlName="streetName" />
      <button *ngIf="form.get('streetName')?.value" mat-icon-button matSuffix (click)="clearField('streetName')" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="50">
      <mat-label>{{ 'LABEL.streetNumber' | translate }}</mat-label>
      <input matInput formControlName="streetNumber" />
      <button *ngIf="form.get('streetNumber')?.value" mat-icon-button matSuffix (click)="clearField('streetNumber')" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="50">
      <mat-label>{{ 'LABEL.city' | translate }}</mat-label>
      <input matInput formControlName="city" />
      <button *ngIf="form.get('city')?.value" mat-icon-button matSuffix (click)="clearField('city')" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="50">
      <mat-label>{{ 'LABEL.province' | translate }}</mat-label>
      <input matInput formControlName="province" />
      <button *ngIf="form.get('province')?.value" mat-icon-button matSuffix (click)="clearField('province')" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="50">
      <mat-label>{{ 'LABEL.country' | translate }}</mat-label>
      <input matInput formControlName="country" />
      <button *ngIf="form.get('country')?.value" mat-icon-button matSuffix (click)="clearField('country')" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ 'LABEL.CANCEL' | translate }}</button>
  <button mat-button color="warn" (click)="reset()" [matTooltip]="'LABEL.RESET_FILTERS_BTN' | translate">
    <mat-icon>filter_alt_off</mat-icon>
    {{ 'LABEL.RESET_FILTERS_BTN' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="search()">{{ 'LABEL.SEARCH' | translate }}</button>
</div>
